/* jslint esversion: 6 */
export default {
  state: {
    token: sessionStorage.getItem('share-token')
      ? JSON.parse(sessionStorage.getItem('share-token'))
      : ''
  },
  mutations: {
    SET_USER_INFO(state, token) {
      state.token = token;
      sessionStorage.setItem('share-token', JSON.stringify(token));
    }
  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js